// Angular
import { inject, Injectable } from "@angular/core";

// Services
import { CookieService } from "ngx-cookie-service";

// Model
import {
    CookieAvailableName,
    DeleteCookieOptionsConfig,
    SetCookieOptionsConfig,
} from "#models/cookie";

@Injectable({
    providedIn: "root",
})
export class CookieBridgeService {
    defaultSetOptions = {
        expires: undefined,
        path: "/",
        domain: undefined,
        secure: undefined,
        sameSite: undefined,
        partitioned: undefined,
    };
    defaultDeleteOptions = {
        path: "/",
        domain: undefined,
        secure: undefined,
        sameSite: undefined,
    };
    service = inject(CookieService);

    check(name: CookieAvailableName) {
        return this.service.check(name);
    }

    get(name: CookieAvailableName) {
        return this.service.get(name);
    }

    getAll() {
        return this.service.getAll();
    }

    set(name: CookieAvailableName, value: string, options: SetCookieOptionsConfig = {}) {
        const opt = {
            ...this.defaultSetOptions,
            ...options,
        };

        return this.service.set(
            name,
            value,
            opt.expires,
            opt.path,
            opt.domain,
            opt.secure,
            opt.sameSite,
            opt.partitioned
        );
    }

    delete(name: CookieAvailableName, options: DeleteCookieOptionsConfig = {}) {
        const opt = {
            ...this.defaultSetOptions,
            ...options,
        };

        return this.service.delete(name, opt.path, opt.domain, opt.secure, opt.sameSite);
    }

    deleteAll(options: DeleteCookieOptionsConfig = {}) {
        const opt = {
            ...this.defaultSetOptions,
            ...options,
        };

        return this.service.deleteAll(opt.path, opt.domain, opt.secure, opt.sameSite);
    }
}
